<!-- <p>snooze-incident-dialog works!</p> -->

<h1 mat-dialog-title>
  Snooze Incident
  <strong
    ><i>{{ data.incidentName | uppercase }}</i></strong
  >
</h1>
<mat-dialog-content class="mat-typography">
  <!-- {{ data | json }} -->
  <div class="incident-dialog-status">
    Please select the duration for snoozing:
  </div>
  <mat-divider></mat-divider>
  <div class="incident-dialog-options">
    <form [formGroup]="snoozeForm">
      <mat-form-field appearance="outline">
        <mat-label>Duration Type</mat-label>
        <mat-select formControlName="durationType">
          <mat-option value="0">Hours</mat-option>
          <mat-option value="1">Days</mat-option>
          <mat-option value="2">Weeks</mat-option>
          <mat-option value="3">Months</mat-option>
          <mat-option value="4">Years</mat-option>
        </mat-select>
      </mat-form-field>
      <br />
      <mat-form-field appearance="outline">
        <mat-label>Duration Size</mat-label>
        <input
          formControlName="durationSize"
          matInput
          (keypress)="inputValidator($event)"
        />
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Close</button>
  <button
    [disabled]="snoozeForm.invalid"
    mat-raised-button
    [mat-dialog-close]="snoozeForm.value"
  >
    Snooze
  </button>
</mat-dialog-actions>
